import { render, staticRenderFns } from "./PriceDescriptionBtn.vue?vue&type=template&id=0dde6dbc&"
import script from "./PriceDescriptionBtn.vue?vue&type=script&lang=js&"
export * from "./PriceDescriptionBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports